<template>
	<div class="watermark">
        <img :src="publicPath+'/media/'+logoURL"/>
	</div>
</template>

<style>
.watermark{
	z-index: 3;
	position: absolute;
	bottom: 10px;
	left: 10px;
	pointer-events: none;
	width: 200px;
	height: auto;
	filter: drop-shadow(0px 0px 6px rgba(0,0,0,0.2));
	transition: opacity .3s ease;
}
@media only screen and (max-width: 1400px) {
	.watermark{
		opacity: 0;
	}
}
</style>

<script>
import {mapGetters} from 'vuex';

export default {
	data: () => ({
    	publicPath: process.env.BASE_URL,
	}),
	computed: {
		...mapGetters(['logoURL']),
	}
}

</script>